Dell = window.Dell || {};
Dell.Types = Dell.Types || {};
Dell.OnlineUtils = Dell.OnlineUtils || {};
Dell.OnlineUtils.AppSettings = Dell.OnlineUtils.AppSettings || {};

// SupportHomepage Constructor -----------------------------------------------------------------------------------
Dell.Types.SupportHomepage = function () {
    var divObj = document.getElementById("divMastheadJSVariables"),
        divObjL = document.getElementById("divMastheadLayoutJSVariable");

    if (divObj !== null && divObj !== undefined) {
        Dell.OnlineUtils.AppSettings.Search = {
            ValidateEntityCheckRegEx: divObj.getAttribute("data-ValidateEntityCheckRegEx"),
            IsValidateEntityCheckEnabled: divObj.getAttribute("data-IsValidateEntityCheckEnabled") === 'True',
            ValidateEntityApiUri: divObj.getAttribute("data-ValidateEntityApiUri"),
            IsAssetSearchEnabled: divObj.getAttribute("data-IsAssetSearchEnabled") === 'True',
            IsSrSearchEnabled: divObj.getAttribute("data-IsSrSearchEnabled") === 'True',
            IsKeyWordSearchEnabled: divObj.getAttribute("data-IsKeyWordSearchEnabled") === 'True',
            IsArticleSearchEnabled: divObj.getAttribute("data-IsArticleSearchEnabled") === 'True',
            IsMastheadProductNameAutoSuggestEnabled: divObj.getAttribute("data-IsMastheadProductNameAutoSuggestEnabled") === 'True',
            MastheadAutoSuggestProductNameApiUri: divObj.getAttribute("data-MastheadAutoSuggestProductNameApiUri"),
            MastheadProductNameAutoSuggestMinLength: divObj.getAttribute("data-MastheadProductNameAutoSuggestMinLength"),
            MastheadAutoSuggestGeneralSearchApiUri: divObj.getAttribute("data-MastheadAutoSuggestGeneralSearchApiUri") + encodeURIComponent('{"lang":"' + Dell.OnlineUtils.Lwp.language + '","geo":"' + Dell.OnlineUtils.Lwp.country + '","product":""}'),
            MastheadAutoSuggestResultDisplayCount: divObj.getAttribute("data-MastheadAutoSuggestResultDisplayCount"),
            MastheadProductNameAutoSuggestFormData: divObj.getAttribute("data-MastheadProductNameAutoSuggestFormData"),
            ProductCatalogAutoSuggestApiUrl: divObj.getAttribute("data-ProductCatalogAutoSuggestApiUrl"),
            DellProductRedirectUrl: divObj.getAttribute("data-DellProductRedirectUrl"),
            EmcProductRedirectUrl: divObj.getAttribute("data-EmcProductRedirectUrl"),
            EmcAuthFormatUri: divObj.getAttribute("data-EmcAuthFormatUri"),
            IsRedirectEmcAssetsIps: divObj.getAttribute("data-IsRedirectEmcAssetsIps"),
            EmcProductRedirectIpsUrl: divObj.getAttribute("data-EmcProductRedirectIpsUrl"),
            isRedirectionMultipleMatch: divObj.getAttribute("data-isRedirectionMultipleMatch"),
            IsDriversIdSearchEnabled: divObj.getAttribute("data-IsDriversIdSearchEnabled"),
            AutosuggestJsUrl: divObj.getAttribute("data-AutosuggestJsUrl"),
            DisplayAutosuggestImage: divObj.getAttribute("data-DisplayAutosuggestImage"),
            IsTwoSectionAutosuggestEnabled: divObj.getAttribute("data-IsTwoSectionAutosuggestEnabled"),
            DellResultTitle: divObj.getAttribute("data-DellResultTitle"),
            CoveoResultTitle: divObj.getAttribute("data-CoveoResultTitle"),
            ViewAllFor: divObj.getAttribute("data-ViewAllFor")
        };
    }

    if (divObjL !== null && divObjL !== undefined) {
        Dell.OnlineUtils.AppSettings.unifiedSearch = divObjL.getAttribute("data-unifiedSearch");
        Dell.OnlineUtils.AppSettings.EnabledUnifiedSearch = divObjL.getAttribute("data-EnabledUnifiedSearch");
        Dell.OnlineUtils.AppSettings.Token = divObjL.getAttribute("data-Token");
    }

    //Constants 
    this.Constants = {};
    this.Constants.Selectors = {};
    this.Constants.CONSUMER_SEGMENT = 'dhs';
    //Lwp
    this.language = Dell.OnlineUtils.Lwp.language;
    this.country = Dell.OnlineUtils.Lwp.country;
    this.customerset = Dell.OnlineUtils.Lwp.customerset;
    this.segment = Dell.OnlineUtils.Lwp.segment;

    //Constants - Commonly Used Selectors
    this.Constants.Selectors.SEARCH_INPUT = "#search-input";
    this.Constants.Selectors.SEARCH_FORM = "#search-form";
    this.Constants.Selectors.SEARCH_SELECTION = "#search-selection";

    this.Constants.Selectors.SEARCH_INPUT_MOB = "#search-input-mob";
    this.Constants.Selectors.SEARCH_FORM_MOB = "#search-form-mob";
    this.Constants.Selectors.SEARCH_SELECTION_MOB = "#search-selection-mob";

    //URLs
    this.Urls = {};
    Dell.OnlineUtils.AppSettings.unifiedSearch = Dell.OnlineUtils.AppSettings.unifiedSearch === undefined ? '{}' : Dell.OnlineUtils.AppSettings.unifiedSearch;
    Dell.OnlineUtils.AppSettings.Token = Dell.OnlineUtils.AppSettings.Token === undefined ? '{}' : Dell.OnlineUtils.AppSettings.Token;
    this.Urls.DomainSelectorEnabled = Dell.OnlineUtils.AppSettings.EnabledUnifiedSearch;
    this.UnifiedSearch = JSON.parse(Dell.OnlineUtils.AppSettings.unifiedSearch);
    this.Urls.Token = JSON.parse(Dell.OnlineUtils.AppSettings.Token);

    this.Urls.LegacySearch = {};
    this.Urls.SupportSearch = {};
    this.Urls.EmcSearch = {};

    for (var i = 0, j = this.UnifiedSearch.length; i < j; i++) {
        if (this.UnifiedSearch[i].Domain === "support") {
            this.Urls.SupportSearch = this.UnifiedSearch[i];
        } else if (this.UnifiedSearch[i].Domain === "dell") {
            this.Urls.LegacySearch = this.UnifiedSearch[i];
        } else {
            this.Urls.EmcSearch = this.UnifiedSearch[i];
        }
    }

    return this;
};

//-----------------------------------
//initializeUX
//Initializes SupportHome Visual Elements (should be run on DOM Ready)
//-----------------------------------
Dell.Types.SupportHomepage.prototype.initializeUX = function() {
    setTimeout(function() {
            //GUI Fixup
            $('html,body').animate({ scrollTop: 0 }, 0);
            //Add supportpage-initialized marker to DOM
            $('#site-wrapper').addClass('supportpage-initialized');

            // sign in
            Dell.Types.SupportHomepage.prototype.signInMenu();

            // side-moblie-menu
            $(document).on('click',
                '#mobile-new-menu',
                function(event) {
                    if ($('.site-canvas').hasClass('site-canvas-mob'))
                        $('.site-canvas').removeClass('site-canvas-mob');

                    $('html').toggleClass('openNav');
                    hideSearchFlyout();
                    hideSignInFlyout();
                    event.stopPropagation();
                });

            $(document).on('click',
                "#mobile-new-search-link",
                function() {
                    if (!$(".auth-page").hasClass('open')) {
                        $('.site-canvas').toggleClass('site-canvas-mob');
                    }
                    hideSignInFlyout();
                    $("#mobile-new-search-link").toggleClass("open-search");
                    $(".search-container").toggleClass("open-search");
                });


            //for touch devices
            $(document).on('touchend',
                '#mobile-new-menu',
                function(event) {
                    event.preventDefault();
                    if ($('.site-canvas').hasClass('site-canvas-mob'))
                        $('.site-canvas').removeClass('site-canvas-mob');

                    $('html').toggleClass('openNav');
                    hideSearchFlyout();
                    hideSignInFlyout();
                    event.stopImmediatePropagation();
                });

            var hideSearchFlyout = function() {
                $("#mobile-new-search-link").removeClass("open-search");
                $(".search-container").removeClass("open-search");
            };

            var hideSignInFlyout = function() {
                $("#signin-link").parent().parent().removeClass("open");
            };
            // ----------------------------------------------------------------------------------------------------
            // Start Country Selector
            // ----------------------------------------------------------------------------------------------------
            $('#countryselector').on('shown.bs.dropdown',
                function() {
                    var $this = $(this);
                    $(document).keypress(function(e) {
                        var key = String.fromCharCode(e.which);
                        $this.find(".dropdown-menu a").each(function(idx, item) {
                            if ($(item).text().trim().charAt(0).toLowerCase() === key) {
                                $(item).focus();
                                return false;
                            }
                        });
                    });
                    $("#countryselector").hasClass('dropdown')
                        ? $("#countryselector").removeClass('dropdown').addClass('dropup')
                        : $("#countryselector").removeClass('dropup').addClass('dropdown');
                });

            // unbind key event when dropdown is hidden
            $('#countryselector').on('hide.bs.dropdown',
                function() {
                    $("#countryselector").hasClass('dropup')
                        ? $("#countryselector").removeClass('dropup').addClass('dropdown')
                        : $("#countryselector").removeClass('dropdown').addClass('dropup');
                });
            // ----------------------------------------------------------------------------------------------------
            // End Country Selector
            // ----------------------------------------------------------------------------------------------------
        },
        0);
};


//-----------------------------------
//Sign Menu
//
Dell.Types.SupportHomepage.prototype.signInMenu = function () {
    if ($(window).width() < 768) {
        // Utility section dropdown links for mobile
        $(document).off('mouseenter', ".masthead__utilities_user,.sign-in-content-wrapper");
        $(document).off('mouseleave', ".masthead__utilities_user,.sign-in-content-wrapper");
        $(document).off('click', ".masthead__utilities_user").on('click', ".masthead__utilities_user", function () {
            if (!$("#mobile-new-search-link").hasClass('open-search')) {
                $('.site-canvas').toggleClass('site-canvas-mob');
            }
            var selfParent = $(this);
            if (selfParent.hasClass('open'))
                selfParent.removeClass('open');
            else
                selfParent.addClass('open');

            $("#mobile-new-search-link").removeClass("open-search");
            $(".search-container").removeClass("open-search");
        });
        var left = 0;
        if ($('.masthead__utilities_cart').length > 0) {
            left = $('.masthead__utilities_cart').position().left;
        } else {
            left = $('.masthead__utilities_menucollapse').position().left;
        }
        $('.sign-in-content-wrapper').css({
            "width": $('#site-wrapper').width(),
            "left": "auto",
            "right": left - $('#site-wrapper').width()
        });
        $('.countrylist').css('left', 0);
    } else {
        $(document).off('click', ".masthead__utilities_user");
        $(document).on('mouseenter', ".masthead__utilities_user,.sign-in-content-wrapper", function () {
            if (!$("#mobile-new-search-link").hasClass('open-search')) {
                $('.site-canvas').toggleClass('site-canvas-mob');
            }
            $(this).addClass('open');
        });
        $(document).on('mouseleave', ".masthead__utilities_user,.sign-in-content-wrapper", function () {
            if (!$("#mobile-new-search-link").hasClass('open-search')) {
                $('.site-canvas').toggleClass('site-canvas-mob');
            }
            $(this).removeClass('open');
        });
        $('.sign-in-content-wrapper').css({
            "width": "320px",
            "left": "auto",
            "right": "0px"
        });
        $('.countrylist').css('left', 'auto');
    }
};


//-----------------------------------
//initializeSearch
//-----------------------------------
Dell.Types.SupportHomepage.prototype.initializeSearch = function () {
    Dell.Types.SupportHomepage.prototype.handleSearch(Dell.Supportpage.Constants.Selectors.SEARCH_FORM,
        Dell.Supportpage.Constants.Selectors.SEARCH_INPUT);
    Dell.Types.SupportHomepage.prototype.handleSearchAutoComplete(Dell.Supportpage.Constants.Selectors.SEARCH_SELECTION,
        Dell.Supportpage.Constants.Selectors.SEARCH_FORM,
        Dell.Supportpage.Constants.Selectors.SEARCH_INPUT);
    //mobile view
    Dell.Types.SupportHomepage.prototype.handleSearch(Dell.Supportpage.Constants.Selectors.SEARCH_FORM_MOB,
        Dell.Supportpage.Constants.Selectors.SEARCH_INPUT_MOB);
    Dell.Types.SupportHomepage.prototype.handleSearchAutoComplete(
        Dell.Supportpage.Constants.Selectors.SEARCH_SELECTION_MOB,
        Dell.Supportpage.Constants.Selectors.SEARCH_FORM_MOB,
        Dell.Supportpage.Constants.Selectors.SEARCH_INPUT_MOB);
};


Dell.Types.SupportHomepage.prototype.mastheadSubmitOmnitureTracking = function (searchTerm, searchDomain) {
    try {
        Dell = window.Dell || {};
        Dell.Metrics = Dell.Metrics || {};
        Dell.Metrics.sc = Dell.Metrics.sc || {};
        Dell.Metrics.sc.coveovisitor = Dell.Metrics.sc.coveovisitor || {};
        Dell.Metrics.sc.searchTerm = searchTerm;
        Dell.Metrics.sc.supportappindex = "111.300.200.001";
        Dell.Metrics.sc.cms = searchDomain != "support" ? "Fuel" : "Coveo";
        Dell.Metrics.sc.pagename = Dell.Metrics.sc.country +
            "|" +
            Dell.Metrics.sc.language +
            "|" +
            Dell.Metrics.sc.segment +
            "|" +
            Dell.Metrics.sc.customerset +
            "|coveo|searchresults";
        Dell.Metrics.sc.pagename += "[tab=" + searchDomain + "]";
        Dell.Metrics.sc.detailpagename = "";
        if (typeof (dellmetrics_pagenav) != 'undefined') {
            dellmetrics_pagenav(Dell.Metrics.sc.pagename);
        }

    } catch (e) {
        console.error("mastheadSubmitOmnitureTracking : " + e.message);
    }
};

//-----------------------------------
//handleSearch
//-----------------------------------
Dell.Types.SupportHomepage.prototype.handleSearch = function (searchForm, searchInput) {
    if (Dell.Supportpage.Urls.DomainSelectorEnabled) {
        $(searchForm).unbind('submit');
        $(searchForm).submit(function (event) {
            $(Dell.Supportpage.Constants.Selectors.SEARCH_INPUT).autocomplete('close');
            event.preventDefault();
            var searchString = $(searchInput).val().replace(/</g, '').replace(/>/g, '').trim();
            if (searchString.length < 1) {
                event.preventDefault();
                return;
            }
            Dell.Types.SupportHomepage.prototype.setSearchProgressAction(true);
            var selection = '';
            if (Dell.Supportpage.Constants.Selectors.SEARCH_INPUT == searchInput) {
                selection = $(Dell.Supportpage.Constants.Selectors.SEARCH_SELECTION).val();
            }
            if (Dell.Supportpage.Constants.Selectors.SEARCH_INPUT_MOB == searchInput) {
                selection = $(Dell.Supportpage.Constants.Selectors.SEARCH_SELECTION_MOB).val();
            }

            var searchUrl;
            if (selection === Dell.Supportpage.Urls.SupportSearch.Domain) {
                if (Dell.Types.SupportHomepage.prototype.ProductSupportData.Title != undefined && Dell.Types.SupportHomepage.prototype.ProductSupportData.Title.length > 0) {
                    Dell.Types.SupportHomepage.prototype.redirectProductSupportPage();
                }
                else {
                    var servieTagRegExPattern = new RegExp(Dell.OnlineUtils.AppSettings.Search.ValidateEntityCheckRegEx);
                    var isValidForEntityCheck = servieTagRegExPattern.test(searchString) && searchString.length > 4;

                    if (isValidForEntityCheck && Dell.OnlineUtils.AppSettings.Search.IsValidateEntityCheckEnabled) {
                        Dell.Types.SupportHomepage.prototype.handleCoveoSearchQuery();
                    }
                    else {
                        Dell.Types.SupportHomepage.prototype.redirectToCoveoSearchPage();
                    }
                }
            }
            else if (selection === Dell.Supportpage.Urls.LegacySearch.Domain) {
                var profile = "?c=" + Dell.Supportpage.country + "&cs=" + Dell.Supportpage.customerSet
                    + "&l=" + Dell.Supportpage.language + "&s=" + Dell.Supportpage.segment + "&cat=sup";
                searchUrl = Dell.Supportpage.Urls.LegacySearch.RedirectUrl + profile + "&k=" + encodeURIComponent(searchString);

            } else {
                searchUrl = Dell.Supportpage.Urls.EmcSearch.RedirectUrl + encodeURIComponent(searchString);
            }

            Dell.Types.SupportHomepage.prototype.mastheadSubmitOmnitureTracking(searchString, selection);
            if (searchUrl != undefined && searchUrl != null && searchUrl.length > 0) {
                SecureRedirectUrl(searchUrl);
            }
        });
    }
};

Dell.Types.SupportHomepage.prototype.getNewHash = function () {
    var hash = location.hash;
    hash = hash.replace("#", "").split("&");
    var newHash = "";
    if (hash !== undefined && hash != null && hash.length > 0) {
        hash.filter(function (val) {
            if (val.split("=")[1] !== undefined && val.split("=")[1] != null && val.split("=")[0].toLowerCase() !== "q")
                newHash += "&" + val.split("=")[0] + "=" + val.split("=")[1];
        });
    }
    return newHash;
};
//-----------------------------------
//executeSearch
//-----------------------------------
Dell.Types.SupportHomepage.prototype.executeSearch = function (searchForm) {
    $(searchForm).submit();
};

//-----------------------------------
//handleSearchAutoComplete
//-----------------------------------
Dell.Types.SupportHomepage.prototype.handleSearchAutoComplete = function (searchSelection, searchForm, searchInput) {

    var serviceUrl = "";
    window.DestroyAutoSuggest(searchInput);
    //var autoSuggestPanel = $(searchInput).width() - $(searchForm + " #btnSearch").width();
    var autoSuggestPanel = $(searchInput).width();

    if (Dell.Supportpage.Urls.DomainSelectorEnabled) {
        var selection = $(searchSelection).val();
        if (selection === Dell.Supportpage.Urls.SupportSearch.Domain) {
            $("#search-form").attr('action', Dell.Supportpage.Urls.SupportSearch.RedirectUrl);
            if (Dell.Supportpage.Urls.SupportSearch.AutoSugEnabled) {
                serviceUrl = Dell.Supportpage.Urls.SupportSearch.ApiUrl;
                serviceUrl += "&language=" + Dell.Supportpage.language;
                Dell.Supportpage.coveoAuto(serviceUrl, Dell.Supportpage.Urls.Token, searchInput, autoSuggestPanel);
            }
        }
        else if (selection === Dell.Supportpage.Urls.LegacySearch.Domain) {
            $("#search-form").attr('action', Dell.Supportpage.Urls.LegacySearch.RedirectUrl);
            serviceUrl = Dell.Supportpage.Urls.LegacySearch.ApiUrl;
            Dell.Supportpage.dellSearchAuto(serviceUrl, searchInput, autoSuggestPanel);
        }
    } else {
        $("#search-form").attr('action', Dell.Supportpage.Urls.LegacySearch.RedirectUrl);
        serviceUrl = Dell.Supportpage.Urls.LegacySearch.ApiUrl;
        Dell.Supportpage.dellSearchAuto(serviceUrl, searchInput, autoSuggestPanel);
    }
};

Dell.Types.SupportHomepage.prototype.dellSearchAuto = function (serviceUrl, searchInput, autoSuggestPanel) {
    window.InitializeAutoSuggest(searchInput, null, serviceUrl, undefined, undefined, undefined, autoSuggestPanel, undefined);
};

Dell.Types.SupportHomepage.prototype.coveoAuto = function (serviceUrl, token, searchInput, autoSuggestPanel) {
    window.InitializeAutoSuggest(searchInput, null, serviceUrl, undefined,
        Dell.Supportpage.Urls.SupportSearch.DefaultListSize, undefined, autoSuggestPanel, token);
};

// Dell.Supportpage Object Initialization ----------------------------------------------
Dell.Supportpage = Dell.Supportpage || new Dell.Types.SupportHomepage();


// UX Initializtion (after DOM Ready) ----------------------------------------------
$(function () {
    Dell.Supportpage.initializeUX();
});

// Footer changes
var footerUrlLwp = function (country, lang, customerset) {
    var isFromSearch = typeof (handleSearchQs) !== 'undefined';
    var urlArray = (!isFromSearch)
        ? location.href.split('?')[0].split('/')
        : (location.href.indexOf('?') > -1
            ? location.href.split('?')[0].split('/')
            : location.href.split('#')[0].split('/'));

    if (window.countryLocalizedSoit && window.countryLocalizedSoit === true) {
        if (window.countryLocalizedSoitThreePath && window.countryLocalizedSoitThreePath === true) {
            urlArray = CountryClickEventBasedOnThreeSegmentedCultureUrl(country, lang, urlArray);
        } else {
            urlArray = CountryClickEventBasedOnCultureUrl(country, lang, urlArray);
        }
    } else {
        if (window.countryLocalizedSoitThreePath && window.countryLocalizedSoitThreePath === true) {
            urlArray = CountryClickEventBasedOnThreeSegmentedUrl(country, lang, customerset, urlArray);
        } else {
            urlArray = CountryClickEventBasedOnSegmentedUrl(country, lang, customerset, urlArray);
        }
    }

    var qStrings = "";
    if (location.search.length > 0) {
        $.each(location.search.split("&"),
            function (index, val) {
                if (index == 0)
                    val = val.substring(1, val.length);
                if (val.split("=")[0].toLowerCase() != "c" &&
                    val.split("=")[0].toLowerCase() != "l" &&
                    val.split("=")[0].toLowerCase() != "s" &&
                    val.split("=")[0].toLowerCase() != "cs" &&
                    val.split("=")[0].toLowerCase() != "sc") {
                    if (typeof (handleLangQs) !== 'undefined' && val.split("=")[0].toLowerCase() === "lang") {
                        // nothing here, just to avoid lang redirection for articles and other siblings 
                    } else {
                        qStrings += qStrings.length == 0
                            ? "?" + val.split("=")[0] + "=" + val.split("=")[1]
                            : "&" + val.split("=")[0] + "=" + val.split("=")[1];
                    }
                }
            });
    }
    var newUrl = urlArray.join("/") + (qStrings.length == 0 ? "" : qStrings);
    if (newUrl.indexOf('#') == -1) {
        var filterSearchCriteria = location.href.split('#');
        if (filterSearchCriteria.length > 1) {
            newUrl = newUrl + "#" + filterSearchCriteria[1];
        }
    }
    var currentUrl = newUrl;
    if (currentUrl.indexOf("lwp=rt", 0) < 0) {
        var splittedUrl = currentUrl.split('#');
        var beforeHash = splittedUrl[0];
        beforeHash += (beforeHash.indexOf("?", 0) > -1 ? "&" : "?") + "lwp=rt";
        currentUrl = beforeHash + (splittedUrl.length > 1 ? "#" + splittedUrl[1] : "");
    }
    setTimeout(function () { SecureRedirectUrl(currentUrl); }, 0);
    event.preventDefault();
};

function CountryClickEventBasedOnSegmentedUrl(country, lang, customerset, urlArray) {
    var tempcustomerSet;
    if (urlArray[3].match(new RegExp("support", "gi"))) {
        if (urlArray.length >= 7) {
            urlArray[5] = country;
            urlArray[6] = lang;
            if (urlArray[7].indexOf('#') > -1) {
                tempcustomerSet = urlArray[7].split('#');
                tempcustomerSet[0] = customerset;
                urlArray[7] = tempcustomerSet[0] + '/#' + tempcustomerSet[1];
            } else {
                urlArray[7] = customerset;
            }
        } else {
            urlArray.push(country);
            urlArray.push(lang);
            if (urlArray[4].indexOf('#') > -1) {
                tempcustomerSet = urlArray[4].split('#');
                urlArray[4] = tempcustomerSet[0];
                urlArray.push(customerset + '/#');
            } else {
                urlArray.push(customerset);
            }
        }
    }
    return urlArray;
}

function CountryClickEventBasedOnThreeSegmentedUrl(country, lang, customerset, urlArray) {
    var tempcustomerSet;
    if (urlArray[3].match(new RegExp("support", "gi"))) {
        if (urlArray.length >= 8) {
            urlArray[6] = country;
            urlArray[7] = lang;
            if (urlArray[8].indexOf('#') > -1) {
                tempcustomerSet = urlArray[8].split('#');
                tempcustomerSet[0] = customerset;
                urlArray[8] = tempcustomerSet[0] + '/#' + tempcustomerSet[1];
            } else {
                urlArray[8] = customerset;
            }
        } else {
            urlArray.push(country);
            urlArray.push(lang);
            if (urlArray[5].indexOf('#') > -1) {
                tempcustomerSet = urlArray[5].split('#');
                urlArray[5] = tempcustomerSet[0];
                urlArray.push(customerset + '/#');
            } else {
                urlArray.push(customerset);
            }
        }
    }
    return urlArray;
}

function CountryClickEventBasedOnCultureUrl(country, lang, urlArray) {
    var tempUrlSet;
    if (urlArray[3].match(new RegExp("support", "gi"))) {
        if (urlArray.length >= 5) {
            if (urlArray[5].indexOf('#') > -1) {
                tempUrlSet = urlArray[5].split('#');
                tempUrlSet[0] = lang + '-' + country;
                urlArray[5] = tempUrlSet[0] + '/#' + tempUrlSet[1];
            } else {
                urlArray[5] = lang + '-' + country;
            }
        } else {
            urlArray.push(lang + '-' + country);
        }
    }
    return urlArray;
}

function CountryClickEventBasedOnThreeSegmentedCultureUrl(country, lang, urlArray) {
    var tempUrlSet;
    if (urlArray[3].match(new RegExp("support", "gi"))) {
        if (urlArray.length >= 6) {
            if (urlArray[6].indexOf('#') > -1) {
                tempUrlSet = urlArray[6].split('#');
                tempUrlSet[0] = lang + '-' + country;
                urlArray[6] = tempUrlSet[0] + '/#' + tempUrlSet[1];
            } else {
                urlArray[6] = lang + '-' + country;
            }
        } else {
            urlArray.push(lang + '-' + country);
        }
    }
    return urlArray;
}


$(document).ready(function () {

    $("html").removeClass('pageFlicker');

    $('#mobile-new-search-link').on('click',
        function () {
            // mobile view search
            setTimeout(function () {
                Dell.Types.SupportHomepage.prototype.handleSearch(
                    Dell.Supportpage.Constants.Selectors.SEARCH_FORM_MOB,
                    Dell.Supportpage.Constants.Selectors.SEARCH_INPUT_MOB,
                    Dell.Supportpage.Constants.Selectors.SEARCH_SELECTION_MOB);
                Dell.Types.SupportHomepage.prototype.handleSearchAutoComplete(
                    Dell.Supportpage.Constants.Selectors.SEARCH_SELECTION_MOB,
                    Dell.Supportpage.Constants.Selectors.SEARCH_FORM_MOB,
                    Dell.Supportpage.Constants.Selectors.SEARCH_INPUT_MOB);
            },
                0);
        });

    function countryselectorLangu() {
        setTimeout(function () {
            if ($("#countryselectorLangu").length > 0 && $("#imgcountryselector").offset() != undefined) {
                $("#countryselectorLangu").offset({ left: $("#imgcountryselector").offset().left });
            }
        },0);
    }

    $(window).on('resize',
        function () {
            Dell.Types.SupportHomepage.prototype.signInMenu();
            Dell.Types.SupportHomepage.prototype.initializeSearch();
            countryselectorLangu();
        });
    countryselectorLangu();

    if (window.accountInfoUrl !== undefined && window.accountInfoUrl !== '') {
        //load account info in ajax
        $.ajax({
            type: 'GET',
            url: window.accountInfoUrl,
            data: { 'callbackUrl': 'REPLACETHIS', 'doCacheUnauth': "1" },
            contentType: 'application/json',
            async: true,
            cache: false,
            success: function (result) {
                if (typeof (result) != 'undefined') {
                    setTimeout(function () {
                        result = result.replace("REPLACETHIS", encodeURIComponent(window.location.href));
                        $(".sign-in-content-wrapper").html(result);
                        var divObjAiSignOut = document.getElementById('divAccountInfoSignOut');
                        if (divObjAiSignOut !== undefined && divObjAiSignOut !== null) {
                            var isEmc = divObjAiSignOut.getAttribute('data-isEmc') === 'True';
                            var isEmcSupportAccess = divObjAiSignOut.getAttribute('data-isEmcSupportAccess') === 'True';
                            if (isEmc && isEmcSupportAccess) {
                                document.getElementById('accInfoBadge').setAttribute("fill", "#000055");
                            } else if (isEmc && !isEmcSupportAccess) {
                                document.getElementById('accInfoBadge').setAttribute("fill", "#ffa500");
                            }
                            document.getElementById('dt-cir-check').style.display = 'block';
                        }
                        Dell.OnlineUtils.Auth = Dell.OnlineUtils.Auth || {};
                        var divObjAccountInfo = document.getElementById("divMastheadAccountInfoJSVariables");
                        if (divObjAccountInfo !== undefined && divObjAccountInfo !== null) {
                            Dell.OnlineUtils.AppSettings.Token = divObjAccountInfo.getAttribute("data-Token");
                            Dell.OnlineUtils.Auth = {
                                LogoUrl: divObjAccountInfo.getAttribute("data-LogoUrl"),
                                IsPremier: divObjAccountInfo.getAttribute("data-IsPremier"),
                                IsChannelPartner: divObjAccountInfo.getAttribute("data-IsChannelPartner"),
                                HeaderText: divObjAccountInfo.getAttribute("data-HeaderText")
                            }
                        }
                        $('.flyout-btn button.btn-default').removeClass('btn-default').addClass('btn-outline-primary');
                        var auth = Dell.OnlineUtils.Auth;
                        if (auth !== undefined) {
                            if (auth.IsPremier.toLowerCase() === 'true') {
                                $('.delllogo').attr('href', auth.LogoUrl);
                                $(".tier1 li").each(function() {
                                    if ($(this).has(".tier2").length === 1) {
                                        return false;
                                    } else {
                                        $(this).find("a").attr('href', auth.LogoUrl);
                                    }
                                    return true;
                                });
                                $(".m-tier1 li").each(function() {
                                    if ($(this).hasClass("active")) {
                                        return false;
                                    } else {
                                        $(this).find("a").attr('href', auth.LogoUrl);
                                    }
                                    return true;
                                });
                            }
                            if (auth.IsPremier.toLowerCase() === 'true' || (auth.IsChannelPartner !== undefined && auth.IsChannelPartner.toLowerCase() === 'true')) {
                                $("#countryselector").html($("#countryselector .dropdown-toggle").html());
                                $("#countryselector").find('div').addClass('pull-left');
                                $("#countryselectorLangu").remove();
                                $("#divFooterLinks").removeClass().addClass('col-sm-12 col-md-12');
                            }
                            $('#user_name').html(auth.HeaderText);
                        }
                        $('#signin-link').html($('#authheaderdiv').html());
                        $('.flyout-btn').click(function (e) {
                            e.preventDefault();
                            var url = $(this).attr('data-href')
                                .replace("REPLACETHIS", encodeURIComponent(window.location.href));
                            SecureRedirectUrl(url);
                            return false;
                        });
                        //Search
                        Dell.Supportpage.Urls.Token = JSON.parse(Dell.OnlineUtils.AppSettings.Token);
                        //Dell.Types.SupportHomepage.prototype.initializeSearch();
                        $("a[id^='lwp_a']").each(function (i, elem) {
                            var elemid = $(elem).attr("id").split('_');
                            $(this).attr("href", '').addClass("dropdown-item").click(function (event) { event.preventDefault(); footerUrlLwp(elemid[2], elemid[3], elemid[4]); });
                        });
                        $("a[id^='lwp_b']").each(function (i, elem) {
                            var elemid = $(elem).attr("id").split('_');
                            $(this).click(function (event) { event.preventDefault(); footerUrlLwp(elemid[2], elemid[3], elemid[4]); });
                        });
                        $("a[id^='lwp_c']").each(function (i, elem) {
                            var elemid = $(elem).attr("id").split('_');
                            $(this).click(function (event) { event.preventDefault(); footerUrlLwp(elemid[2], elemid[3], elemid[4]); });
                        });
                        //$(".countrylist a").each(function () { $(this).attr("href", '').addClass("dropdown-item"); });
                    },
                        0);
                }
            },
            failure: function (error) {
                console.error(error);
            }
        });
    }
});

function SecureRedirectUrl(url) {
    window.location.href = url;
}

Dell.Types.SupportHomepage.prototype.ProductSupportData = [];
Dell.Types.SupportHomepage.prototype.redirectProductSupportPage = function () {
    var arrdata = Dell.Types.SupportHomepage.prototype.ProductSupportData;
    if (arrdata.uri.length > 0) {
        SecureRedirectUrl(arrdata.uri);
    }
};

$("#masthead-search, #masthead-search-mob").mouseover(function () {

    document.getElementById("search-selection-mob")
        .addEventListener("change",
            function() {
                Dell.Supportpage.handleSearchAutoComplete('#search-selection-mob',
                    '#search-form-mob',
                    '#search-input-mob');
            },
            false);

    document.getElementById("search-selection")
        .addEventListener("change",
            function() {
                Dell.Supportpage.handleSearchAutoComplete('#search-selection', '#search-form', '#search-input');
            },
            false);

    Dell.Types.SupportHomepage.prototype.initializeSearch();
    $('#masthead-search, #masthead-search-mob').unbind('mouseover');
});